import { memo } from "react"
import { Link } from "react-router-dom"
import { useTranslation, Trans } from "react-i18next"
import { companyExpensesPath } from "@oysterhr/router"
import { Alert } from "@oysterhr/ui"
import { Authorized } from "@oysterhr/auth"
import { Authorization } from "@oysterhr/auth/types"

interface Props {
  className?: string
  companyId?: string
  payrollContext?: { authorizations?: Authorization }
}

const PayrollChangeInfo = memo(
  ({ className, companyId, payrollContext: payroll_context }: Props) => {
    const { t } = useTranslation("Payroll")

    if (!companyId) {
      return null
    }

    return (
      <Alert variation="info" className={className}>
        <Alert.Icon />
        <Alert.Content>
          <div data-testid="payroll-change-info">
            <Authorized
              to={["manage_expenses"]}
              on={payroll_context}
              fallback={<Trans t={t} i18nKey="changeAlert.noLinkToExpenses" />}
            >
              <Trans
                t={t}
                i18nKey="changeAlert.linkToExpenses"
                components={{
                  a: <Link to={companyExpensesPath(companyId)} className="underline" />,
                }}
              />
            </Authorized>
          </div>
        </Alert.Content>
      </Alert>
    )
  },
)

export { PayrollChangeInfo }
